import type { PageTeaserSkeletonMarker, PageTeaserView } from "@slfinrtl/ui-bff-routes"

export const isPageTeaserSkeletonMarker = (value: unknown): value is PageTeaserSkeletonMarker =>
	typeof value === "object" && value !== null && "type" in value && value.type === "skeleton"

export const getPageTeaserValue = <T>(value: T | PageTeaserSkeletonMarker | undefined): T | undefined =>
	isPageTeaserSkeletonMarker(value) ? undefined : value

export const getAppTitleForPageTeaser = (view?: PageTeaserView): string => {
	if (!view) {
		return ""
	}

	const heading = getPageTeaserValue(view.heading) ?? ""
	const context = getPageTeaserValue(view.context)

	return context ? `${context}: ${heading}` : heading
}
